var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 295,
    viewBox: "0 0 267 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.8535,
    cy: 171.853,
    r: 171.853,
    fill: "#5CE7A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1699_1693",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -77,
    y: 0,
    width: 344,
    height: 344
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.8535,
    cy: 171.853,
    r: 171.853,
    fill: "#5CE7A3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1699_1693)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.934 136.618C137.162 134.246 138.458 131.697 140.83 130.925L157.923 125.357C160.295 124.585 162.844 125.881 163.616 128.253C164.389 130.625 163.092 133.174 160.72 133.946L143.628 139.514C141.256 140.286 138.707 138.99 137.934 136.618ZM82.2038 154.858C81.4312 152.486 82.7277 149.937 85.0996 149.164L102.192 143.597C104.564 142.824 107.113 144.121 107.886 146.493C108.658 148.864 107.362 151.413 104.99 152.186L87.8973 157.753C85.5254 158.526 82.9763 157.23 82.2038 154.858ZM160.41 169.915C161.212 167.998 160.308 165.792 158.391 164.99C156.473 164.188 154.268 165.092 153.466 167.009C150.86 173.236 147.745 177.171 144.594 179.592C141.466 181.996 138.117 183.053 134.765 183.24C127.887 183.624 120.876 180.329 116.512 176.999C114.86 175.738 112.498 176.056 111.237 177.708C109.976 179.361 110.293 181.723 111.946 182.984C117.153 186.958 125.899 191.274 135.184 190.756C139.913 190.492 144.747 188.969 149.181 185.561C153.592 182.172 157.418 177.065 160.41 169.915Z",
    fill: "#232531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.44391 83.9743C-37.6197 86.8628 -46.6145 64.9579 -47.3398 53.6443L54.2134 -30.8462L173.176 -0.516256C174.143 9.35301 180.59 27.0192 160.279 39.1511C140.189 51.1516 111.425 43.229 103.783 35.1348C109.457 41.6746 104.753 61.1974 79.0113 68.2178C52.9106 75.3362 40.2793 65.1986 36.8942 53.6443C35.927 62.5508 22.7319 81.0857 -7.44391 83.9743Z",
    fill: "#232531"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSmile);
export default __webpack_public_path__ + "static/media/green-smile.cc23292ec975895cab4466e21a4676ba.svg";
export { ForwardRef as ReactComponent };